import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ManufacturingHero from "./sections/ManufacturingHero";
import Expertise from "./sections/Expertise";
import Partners from "./sections/Partners";
import ProductPreview from "./sections/ProductPreview";
import Compliance from "./sections/Compliance";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ManufacturingHero />
      <Expertise />
      <Partners />
      <ProductPreview />
      <Compliance />
      <Footer />
    </div>;
}